import 'waypoints/lib/noframework.waypoints'

export default class Waypoints {
    constructor() {
        this.initWaypoints()
        this.observeReflow()
    }

    initWaypoints() {
        document.querySelectorAll('[class*=so-widget]').forEach(el => {
            new Waypoint({
                element: el,
                handler: function() {
                    this.element.classList.add('widget-is-visible');
                },
                offset: '80%'
            })
        })

        document.querySelectorAll('.panel-grid').forEach(el => {
            new Waypoint({
                element: el,
                handler: function() {
                    this.element.classList.add('row-is-visible');
                },
                offset: '80%'
            })
        })
    }

    observeReflow() {
        let lastHeight = document.body.scrollHeight
        let refreshTimeout

        const reflowObserver = new ResizeObserver(() => {
            const newHeight = document.body.scrollHeight
            if (newHeight !== lastHeight) {
                lastHeight = newHeight

                // Debounce optional, but good for high-churn UIs
                clearTimeout(refreshTimeout)
                refreshTimeout = setTimeout(() => {
                    Waypoint.refreshAll()
                }, 100)
            }
        })

        reflowObserver.observe(document.body);
    }
}